export const TABLE = 'table';
export const BAR = 'bar';
export const LINE = 'line';
export const PIE = 'pie';
export const PIVOT = 'pivot';
export const BARLINE = 'bar_line';
export const STACKED_CHART = 'stacked';
